import { ISchoolData } from './i-schooldata';
import { Shift } from '../shifts/shift';
import { EmployeeSchoolData } from '../employee/employee-school-data';

export class SchoolData implements ISchoolData {
    Id: number;
    Number: number;
    Name: string;
    Mail: string;
    shifts: Shift[];
    Address: string;
    PhoneNumber: string;
    Director: EmployeeSchoolData;

    constructor() {
        this.Id = -1;
        this.Number = -1;
        this.Name = '';
        this.Mail = '';
        this.Address = '';
        this.PhoneNumber = '';
        this.shifts = [];
        this.Director = new EmployeeSchoolData();
    }
}





// WEBPACK FOOTER //
// ./src/app/main/models/school-data/schooldata.ts